<template>
  <iframe
    v-if="src"
    :src="src"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
import { getPartnerData } from 'fleetmap-partners'
import axios from 'axios'

export default {
  name: 'Dashboard',
  data() {
    return {
      src: ''
    }
  },
  async created() {
    const partnerData = getPartnerData()
    if (partnerData && partnerData.partnerId === 5) {
      const cookie = await axios.get('/pinmeapi/cookie/get', { withCredentials: true }).then(d => d.data)
      this.src = 'https://dashboard.moviflotte.com?token=' + cookie.replace('JSESSIONID=', '')
    } else {
      this.src = '/dashboard/'
    }
  }
}
</script>

<style scoped>
iframe {
  border-width: 0;
}
</style>
